import { Slide } from "react-reveal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { settings } from "../reusables/carousel";
import TestimonialCard from "../reusables/TestimonialCard";

const HomeTestimonials = () => {
  return (
    <section className="section-spacing-50 paint-colors-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head width-600">
              <Slide top>
                <h2 className="section-title big-title">
                  <span className="flexi-gold">What they're saying</span> about
                  Flexi Painters
                </h2>
              </Slide>
            </div>
            <div className="section-body width-600 section-spacing-30 no-padding-top">
              <ul className="testimonials-container slider-items-container">
                <Slider {...settings}>
                  <TestimonialCard
                    testimonial="Flexi Painters delivered exceptional workmanship, clean finishes, and professional service from start to finish. Their attention to detail and commitment to quality set them apart."
                    giver="Eng. Bataze Anthony, MD, Bataze Contractors & Arhitects"
                  />
                  <TestimonialCard
                    testimonial="We wanted a painting company that could deliver quality without constant supervision. Flexi Painters handled the entire project professionally and completed it on schedule. The final result transformed our property."
                    giver="David Ssemwanga, Property Developer"
                  />
                  <TestimonialCard
                    testimonial="Flexi Painters exceeded our expectations. Their team was punctual, professional, and delivered a flawless finish throughout our office renovation. The quality of work and attention to detail were impressive."
                    giver="Sarah Nakato, Operations Manager"
                  />
                  <TestimonialCard
                    testimonial="From the initial site visit to the final inspection, Flexi Painters maintained excellent communication and workmanship. Their clean execution and commitment to quality make them a company I would gladly recommend."
                    giver="Grace Namubiru, Homeowner"
                  />
                </Slider>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeTestimonials;
